<template>
  <b-container class="site-detail__reportsettings contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('config.settingsbackendlink')}}</h2>
      </b-col>
      <b-col>
        <div class="actions">
          <button class="btn btn--success" v-on:click="save">
              <span class="btn__icon">
                  <font-awesome-icon :icon="['fal','save']" class="icon"></font-awesome-icon>
              </span>
            {{$t('config.save')}}
          </button>
        </div>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <b-form-group :label="$t('config.backendlink')">
          <b-form-input v-model="backendLink"
            type="text"
            :placeholder="placeholder"
            id="backendLink"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'SiteDetailSettingsBackendlink',

  mixins: [mixins],

  computed: {

    ...mapState('site', [
      'siteDetail'
    ]),

    placeholder () {
      if (this.siteDetail.data.app_type === 'Wordpress') {
        return 'wp-admin/index.php'
      }

      return 'administrator/index.php'
    }
  },

  data () {
    return {
      backendLink: ''
    }
  },

  watch: {
    'siteDetail': function () {
      this.preparePage()
    }
  },

  methods: {

    ...mapMutations('site', [
      'closeSiteDetailPageConfiguration'
    ]),

    ...mapActions('site', [
      'saveSiteConfiguration'
    ]),

    preparePage () {
      this.backendLink = this.getConfigValue(
        this.siteDetail.data.configuration,
        'backend_link',
        ''
      )
    },

    save () {
      let payload = {
        id: this.siteDetail.id,
        configuration: {
          'backend_link': this.backendLink
        }
      }

      this.saveSiteConfiguration(payload)
    }
  }
}
</script>
